module.exports = __webpack_public_path__ + "img/26.9.TU.08dd436f.png";